import React from 'react';
import { connect } from 'react-redux';
import SocialModule from 'components/organisms/social/SocialModule';
import { toggleObjectiveExpansion } from 'services/social/duck';

class ObjectiveVisibilityContainer extends React.Component {
    render() {
        const { children, initialExpand, hide, toggleExpand, ...rest } = this.props;
        if (!children) {
            return null;
        }

        return <SocialModule
            initialExpand={initialExpand}
            hide={hide}
            toggleExpand={toggleExpand}
            {...rest}>
            {children}
        </SocialModule>;
    }
}

ObjectiveVisibilityContainer.propTypes = SocialModule.propTypes;

export default connect((state, props) => {
    const { hide, initialExpand } = state.social.facebook.objectives[props.objective].expand;
    return { hide, initialExpand };
}, (dispatch, props) => ({
    toggleExpand: () => dispatch(toggleObjectiveExpansion(props.objective))
}))(ObjectiveVisibilityContainer);



// WEBPACK FOOTER //
// ./src/containers/dashboards/social/ObjectiveVisibilityContainer.js